import React, { useState, useEffect } from 'react';
import '../components/css/gallery.css';
import { FaTimes, FaChevronLeft, FaChevronRight, FaSearchPlus } from 'react-icons/fa';

import img1 from "../images/galleryImage/3.JPG";
import img2 from "../images/galleryImage/showimage1.webp";
import img3 from "../images/galleryImage/showimage2.webp";
import img4 from "../images/galleryImage/showimage3.webp";
import img5 from "../images/galleryImage/IMG_8482.JPG";
import img6 from "../images/galleryImage/IMG_5115.JPG";
import img7 from "../images/galleryImage/bgimage.jpeg";
import imgNan8 from "../images/galleryImage/1.webp";
import imgNan9 from "../images/galleryImage/2.webp";
import imgNan10 from "../images/galleryImage/3.webp";
import imgNan11 from "../images/galleryImage/4.webp";
import imgNan12 from "../images/galleryImage/5.webp";
import imgNan13 from "../images/galleryImage/6.webp";
import imgNan14 from "../images/galleryImage/7.webp";
import imgNan15 from "../images/galleryImage/8.webp";
import imgNan16 from "../images/galleryImage/10.webp";
import imgNan17 from "../images/galleryImage/11.webp";
import imgNan18 from "../images/galleryImage/14.webp";



const allImages = [
    { id: 1, src: img2, alt: 'Bridal Mehandi Design', category: 'Bridal', title: 'Bridal Elegance' },
    { id: 2, src: img3, alt: 'Arabic Mehandi Pattern', category: 'Arabic', title: 'Arabic Fusion' },
    { id: 3, src: img4, alt: 'Traditional Mehandi', category: 'Traditional', title: 'Heritage Design' },
    { id: 4, src: img5, alt: 'Festive Mehandi', category: 'Festival', title: 'Festival Special' },
    { id: 5, src: img6, alt: 'Bridal Full Hands', category: 'Bridal', title: 'Full Hand Bridal' },
    { id: 6, src: img1, alt: 'Modern Arabic Design', category: 'Arabic', title: 'Modern Arabic' },
    { id: 7, src: img7, alt: 'Classic Mehandi', category: 'Traditional', title: 'Classic Pattern' },
    { id: 8, src: img2, alt: 'Bridal Feet Design', category: 'Bridal', title: 'Bridal Feet' },
    { id: 9, src: img3, alt: 'Arabic Bold Design', category: 'Arabic', title: 'Bold Arabic' },
    { id: 10, src: img4, alt: 'Eid Special Mehandi', category: 'Festival', title: 'Eid Special' },
    { id: 11, src: img5, alt: 'Intricate Bridal', category: 'Bridal', title: 'Intricate Bridal' },
    { id: 12, src: img1, alt: 'Traditional Feet', category: 'Traditional', title: 'Traditional Feet' },



    { id: 12, src: imgNan8, alt: 'Traditional Feet', category: 'Bridal', title: 'Traditional Feet' },
    { id: 12, src: imgNan9, alt: 'Traditional Feet', category: 'Bridal', title: 'Traditional Feet' },
    { id: 12, src: imgNan10, alt: 'Traditional Feet', category: 'Bridal', title: 'Traditional Feet' },
    { id: 12, src: imgNan11, alt: 'Traditional Feet', category: 'Bridal', title: 'Traditional Feet' },
    { id: 12, src: imgNan12, alt: 'Traditional Feet', category: 'Bridal', title: 'Traditional Feet' },
    { id: 12, src: imgNan13, alt: 'Traditional Feet', category: 'Bridal', title: 'Traditional Feet' },
    { id: 12, src: imgNan14, alt: 'Traditional Feet', category: 'Bridal', title: 'Traditional Feet' },
    { id: 12, src: imgNan15, alt: 'Traditional Feet', category: 'Bridal', title: 'Traditional Feet' },
];

const categories = ['All', 'Bridal', 'Arabic', 'Traditional', 'Festival'];

function GalleryImageComponent() {
    const [activeCategory, setActiveCategory] = useState('All');
    const [lightboxIndex, setLightboxIndex] = useState(null);
    const [loaded, setLoaded] = useState({});

    const filtered = activeCategory === 'All'
        ? allImages
        : allImages.filter(img => img.category === activeCategory);

    const openLightbox = (index) => {
        setLightboxIndex(index);
        document.body.style.overflow = 'hidden';
    };

    const closeLightbox = () => {
        setLightboxIndex(null);
        document.body.style.overflow = '';
    };

    const prevImage = () => {
        setLightboxIndex(i => (i - 1 + filtered.length) % filtered.length);
    };

    const nextImage = () => {
        setLightboxIndex(i => (i + 1) % filtered.length);
    };

    useEffect(() => {
        const handleKey = (e) => {
            if (lightboxIndex === null) return;
            if (e.key === 'Escape') closeLightbox();
            if (e.key === 'ArrowLeft') prevImage();
            if (e.key === 'ArrowRight') nextImage();
        };
        window.addEventListener('keydown', handleKey);
        return () => window.removeEventListener('keydown', handleKey);
    }, [lightboxIndex, filtered.length]);

    return (
        <div className="gallery-section-wrap">
            <div className="container">
                <div className="gallery-filters d-flex justify-content-center flex-wrap gap-2 my-4">
                    {categories.map(cat => (
                        <button
                            key={cat}
                            className={`gallery-filter-btn ${activeCategory === cat ? 'active' : ''}`}
                            onClick={() => setActiveCategory(cat)}
                        >
                            {cat}
                            <span className="filter-count">
                                {cat === 'All' ? allImages.length : allImages.filter(i => i.category === cat).length}
                            </span>
                        </button>
                    ))}
                </div>

                <div className="gallery-masonry">
                    {filtered.map((img, index) => (
                        <div
                            key={img.id}
                            className="gallery-item"
                            onClick={() => openLightbox(index)}
                        >
                            <img
                                src={img.src}
                                alt={img.alt}
                                className={`gallery-img ${loaded[img.id] ? 'loaded' : ''}`}
                                loading="lazy"
                                onLoad={() => setLoaded(prev => ({ ...prev, [img.id]: true }))}
                            />
                            <div className="gallery-item-overlay">
                                <FaSearchPlus className="gallery-zoom-icon" />
                                <div className="gallery-item-info">
                                    <span className="gallery-item-category">{img.category}</span>
                                    <h5 className="gallery-item-title">{img.title}</h5>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>

            {lightboxIndex !== null && (
                <div className="lightbox-overlay" onClick={closeLightbox}>
                    <button className="lightbox-close" onClick={closeLightbox}>
                        <FaTimes />
                    </button>
                    <button
                        className="lightbox-nav lightbox-prev"
                        onClick={(e) => { e.stopPropagation(); prevImage(); }}
                    >
                        <FaChevronLeft />
                    </button>
                    <div className="lightbox-content" onClick={(e) => e.stopPropagation()}>
                        <img
                            src={filtered[lightboxIndex].src}
                            alt={filtered[lightboxIndex].alt}
                            className="lightbox-img"
                        />
                        <div className="lightbox-caption">
                            <span className="lightbox-category">{filtered[lightboxIndex].category}</span>
                            <h4 className="lightbox-title">{filtered[lightboxIndex].title}</h4>
                            <span className="lightbox-counter">{lightboxIndex + 1} / {filtered.length}</span>
                        </div>
                    </div>
                    <button
                        className="lightbox-nav lightbox-next"
                        onClick={(e) => { e.stopPropagation(); nextImage(); }}
                    >
                        <FaChevronRight />
                    </button>
                </div>
            )}
        </div>
    );
}

export default GalleryImageComponent;
